/**
 * Leviathan Web - New Customer Page
 * Quasar Prime LLC
 * Aggressive Tactical Industrial Design
 */

import { Link } from 'react-router-dom';
import CustomerForm from '@components/customers/CustomerForm';

const NewCustomerPage = () => {
  return (
    <div className="space-y-6">
      {/* Header with geometric frame */}
      <div className="relative">
        <div className="absolute -left-4 top-0 bottom-0 w-1 bg-gradient-to-b from-amber via-steel to-amber shadow-[0_0_8px_rgba(255,149,0,0.6)]" />
        <div className="border-l-4 border-amber pl-6 relative">
          <div className="flex items-center justify-between">
            <div>
              <h1
                className="text-4xl font-display font-bold text-steel tracking-wide uppercase"
                style={{ textShadow: '0 0 20px rgba(92, 140, 199, 0.6)' }}
              >
                New Customer
              </h1>
              <div className="flex items-center space-x-4 mt-2">
                <Link
                  to="/customers"
                  className="text-text-secondary text-sm font-mono hover:text-amber transition-colors"
                >
                  &larr; Back to Customers
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Customer Form */}
      <CustomerForm />
    </div>
  );
};

export default NewCustomerPage;
